import React, { Component } from 'react';
import $ from 'jquery';

const contentHTML = `
<!DOCTYPE html>
<html lang="en-us">
    <head>
        <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
        <meta name="generator" content="Hugo 0.87.0" />
        <meta charset="utf-8" />
        <meta http-equiv="x-ua-compatible" content="IE=edge,chrome=1" />
        <title>Traffic Infuser | trafficInfuser.com</title>
        <meta name="description" content="Drive massive targeted traffic to your blog with only 15 minutes of work a day." />
        <meta name="viewport" content="width=device-width,minimum-scale=1" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://trafficinfuser.com/" />
        <meta property="og:title" content="TrafficInfuser  | Blog Traffic Infuser" />
        <meta property="og:description" content="Drive massive targeted traffic to your blog with only 15 minutes of work a day." />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://trafficinfuser.com/" />
        <meta property="twitter:title" content="TrafficInfuser  | Blog Traffic Infuser" />
        <meta property="twitter:description" content="Drive massive targeted traffic to your blog with only 15 minutes of work a day." />
        <meta name="twitter:site" content="@trafficinfuser" />
        <meta property="og:image" content="https://trafficinfuser.com/cover.png" />
        <meta property="twitter:image" content="https://trafficinfuser.com/cover.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://trafficinfuser.com/images/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="https://trafficinfuser.com/images/favicon-16x16.png" />
        <link rel="manifest" href="https://trafficinfuser.com/site.webmanifest" />
       
        <link rel="shortcut icon" href="images/favicon.ico" >

        <link href="css/app.css" rel="stylesheet" />
   
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
   


<script data-my-script="">
var i = 0;
var n = 0;
var txt = "traffic!";
var speed = 200;
var speedHold = 600;

var verbArray = ["Get","Get","Go&nbsp;"];
var textArray = ["traffic!","clicks","viral"];
var textIndex =0;

function loopDynamicText()
{
    if (textIndex >=3)
    {
        textIndex = 0;
    }

    txt = textArray[textIndex];
    verb = verbArray[textIndex];
    document.getElementById("dynamicVerb").innerHTML = verb;
    typeIt();

    textIndex = textIndex +1;

    setTimeout( loopDynamicText, 5000);
}

function typeIt()
{
    i = 0;
    n = 0;
    typeWriter(); 
}

function typeWriter() {
  if (i <= txt.length) {
    //console.log(txt.substring(1,i));
    document.getElementById("dynamicTitle").innerHTML ="<mark>"+txt.substring(0,i)+"<mark/>";
    i++;
    setTimeout(typeWriter, speed);
  } else
  {
    n=i  
    setTimeout(untypeWriter, speedHold);
    return;
  }

}

function untypeWriter() {
   if (n >= 0) {
    document.getElementById("dynamicTitle").innerHTML = "<mark>"+txt.substring(0,n)+"<mark/>";
    //console.log(document.getElementById("demo").innerHTML);
    n=n-1;    
    setTimeout(untypeWriter, speed);
  }

}

</script>

<script data-my-script="">

    var randomImages = [
        "images/front-image-guy-hands-up.png",
        "images/front-image-girl-open-mouth.png"
        ];
    
        var callback = function(){
        
            try
            {
                var sideImage = getLocalStorageItem("trafficInfuserSideImage");
            
                if (sideImage == null || sideImage==="")
                {
                    var size = randomImages.length
                    var x = Math.floor(size*Math.random())
                    
                    document.getElementById("dynamicImage").src = randomImages[x];

                    setLocalStorageItem("trafficInfuserSideImage", randomImages[x]);
                } else
                {  
                    document.getElementById("dynamicImage").src = sideImage;
                }
            } catch (error) {
                console.error(error);
            }

            loopDynamicText();

        };

        if (
            document.readyState === "complete" ||
            (document.readyState !== "loading" && !document.documentElement.doScroll)
        ) {
        callback();
        } else {
        document.addEventListener("DOMContentLoaded", callback);
        }

   
    function setLocalStorageItem(key,value)
    {
        try
        {
            window.localStorage.setItem(key,value);

        } catch (error) {
            console.error(error);
        }
    }

    function getLocalStorageItem(key)
    {
        var value = null;
        try
        {
            value = window.localStorage.getItem(key);

        } catch (error) {
            console.error(error);
        }

        return value;
    }

    </script>
    

    </head>
    <body>
        <header class="header-main-core" role="banner">
            <div class="container-main-object">
                <div class="header-main-core__inner">
                    <div class="header-main-core__primary">
                        <a href="/" class="header-main-core__brand" style="text-decoration: none;">
                                                 
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="35" height="35" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1040 1056">
                                <title>TrafficInfuser</title>
                                <path d="M210 899q-10 21-16 30t-21.5 20.5t-41 17T65 973q1-32 4.5-54.5T77 883t13.5-23t17-14.5T130 833q39-19 62-37l-39-50q-15 11-52 30q-38 19-57.5 39T12 880.5T0 1004l1 33l31-1q62 0 103-6t66-21.5t38-31.5t27-45q15-31 22-44l-47-43q-7 9-13.5 19.5t-9.5 17t-8 17.5zm495-694q-53 0-90.5 37.5T577 333q0 35 17 64.5t46.5 46.5t64.5 17t64.5-17t46.5-46.5t17-64.5q0-21-6.5-40.5t-18-35.5t-27.5-27.5t-35.5-18T705 205zm-.5 192q-26.5 0-45-19T641 333t18.5-45t45.5-19q17 0 32 8.5t23.5 23.5t8.5 32q0 26-19 45t-45.5 19zM1024 45q-1-12-9.5-20.5T994 15q-4 0-10.5-.5T955 14t-45 1t-56.5 4.5t-66 9t-71 15.5T643 67q-92 34-163 117q-9 10-17.5 21.5T445 233t-16 27.5t-17.5 32T396 323t-17 33.5t-15 29.5l-7 14l-6 12.5l-7 13.5l-6 11.5l-6 12l-6 10.5H148q-14 0-24 10L7 598q-12 13-6.5 30.5T24 650l191 44q12 15 69 78l72 80l39 165q4 18 22 23q1 1 2.5 1t3.5.5t3 .5q12 0 21-8l119-118q2-2 4.5-5t4-6t2-6.5t.5-6.5V727q7-5 17.5-11t29-16t24.5-13q18-11 75-40.5t93.5-51T873 556q45-40 68-74.5t41-83.5q15-41 25-92t13.5-92t4.5-83t0-59t-1-27zM922 375q-16 43-34.5 71T831 508q-18 16-54 37t-89 48t-71 38q-81 45-92 54q-3 2-5 5t-3.5 6t-2.5 6.5t-1 7.5v167l-68 74l-28-121q-3-9-8-14q-145-162-154-172q-4-4-8.5-7t-9.5-4L91 600l72-76h182q2 0 5-.5t5.5-1.5t5-2.5t4.5-3t3.5-3.5t3.5-5q14-22 49-93q3-5 16.5-32t18.5-37.5t17-33t19.5-35T510 250t18-25q60-70 137-98q133-50 296-49q3 184-39 297z" 
                                fill="#ff642d"/>
                            </svg>
                              
                            <span class="heading-core-extra-large" style="font-size:20px;padding-left:10px;padding-right:40px;color:#ff642d;">Traffic Infuser</span>  
                                                           
                     
                        </a>
                        <nav class="navbar-main-core header-main-core__navbar" role="navigation">
                            <ul class="navbar-main-core__list">
                                <li class="navbar-main-core__item">
                                    <a href="#how-it-works" class="navbar-main-core__link">How It Works</a>
                                </li>
                                <li class="navbar-main-core__item">
                                    <a href="#demo" class="navbar-main-core__link">Demo</a>
                                </li>
                                <li class="navbar-main-core__item">
                                    <a href="pricing.html" class="navbar-main-core__link">Pricing</a>
                                </li>
                                <!--
                                <li class="navbar-main-core__item">
                                    <a href="" class="navbar-main-core__link" style="font-weight: bold;">Blog</a>
                                </li>
                                -->
                             </ul>
                        </nav>
                    </div>
                    <ul class="header-main-core__actions">
                        <li class="header-main-core__login">
                            <a href="/login" class="button-main-core button-main-core--s button-main-core--brand button-main-core--outlined">Log In</a>
                        </li>
                        <li class="header-main-core__signup">
                            <a href="/signup" class="button-main-core button-main-core--s button-main-core--brand">Try It Free</a>
                        </li>
                    </ul>
                    <!-- mobile menu bars -->
                    <button class="header-main-core__nav-trigger">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <rect x="6" y="10" width="20" height="2" fill="#9da9bf"></rect>
                            <rect x="6" y="15" width="20" height="2" fill="#9da9bf"></rect>
                            <rect x="6" y="20" width="20" height="2" fill="#9da9bf"></rect>
                        </svg>
                    </button>
                    <div class="mobile-main-navigation">
                        <div class="mobile-main-navigation__content">
                            <div class="container-main-object">
                                <div class="grid-main-core">
                                  
                                    <div class="grid-main-core__unit grid-main-core__unit--6of12@m">
                                        <h5 class="mobile-main-navigation__heading">Pricing</h5>
                                        <ul class="mobile-main-navigation__list margin-core-main-bottom-6">
                                            <li class="mobile-main-navigation__item">
                                                <a href="pricing.html" class="mobile-main-navigation__link">Pricing</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <!--
                                    <div class="grid-main-core__unit grid-main-core__unit--6of12@m">
                                        <h5 class="mobile-main-navigation__heading">Resources</h5>
                                        <ul class="mobile-main-navigation__list margin-core-main-bottom-6">
                                           <li class="mobile-main-navigation__item">
                                                <a href="/blog/" class="mobile-main-navigation__link">Blog</a>
                                            </li>
                                        </ul>
                                    </div>
                                    -->
                                    <div class="grid-main-core__unit grid-main-core__unit--6of12@m">
                                        <h5 class="mobile-main-navigation__heading">Company</h5>
                                        <ul class="mobile-main-navigation__list margin-core-main-bottom-6">
                                            <li class="mobile-main-navigation__item">
                                                <a href="about-us.html" class="mobile-main-navigation__link">About Us</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="grid-main-core__unit grid-main-core__unit--6of12@m">
                                        <h5 class="mobile-main-navigation__heading">Help &amp; Support</h5>
                                        <ul class="mobile-main-navigation__list margin-core-main-bottom-6">
                                            <li class="mobile-main-navigation__item">
                                                <a href="contact-us.html" class="mobile-main-navigation__link">Contact Us</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main role="main">
            <section class="core-block-sectionX core-block-section--hero core-block-section--white padding-main-top core-block-section--cut core-block-section--cut-bottom-right core-block-section--elevated padding-main-bottom-0@xl gray-background" style="background-color: green;">
                <div class="container-main-object">
                    <div class="grid-main-core">
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@l padding-main-top-10@xl">

                            <!-- Begin icons -->    
                            <div style="float:left;">
                                    <div style="white-space: nowrap;display: inline-block;">
                                            <img alt="Facebook" src="images/facebook-blog-traffic.png" style="height:45px"/>
                                    </div>
                                    <div style="white-space: nowrap;display: inline-block;padding-right:5px;">
                                            <img alt="Quora" src="images/quora-blog-traffic.png" style="height:45px"/>
                                    </div>
                                    <div style="white-space: nowrap;display: inline-block;padding-right:5px;">
                                            <img alt="Reddit" src="images/twitter-blog-traffic.png" style="height:45px"/>
                                    </div>
                                    <div style="white-space: nowrap;display: inline-block;padding-right:5px;">
                                            <img alt="Twitter" src="images/reddit-blog-traffic.png" style="height:45px"/>
                                    </div>
                                    <div style="white-space: nowrap;display: inline-block;padding-right:5px;">
                                            <img alt="Youtube" src="images/youtube-blog-traffic.png" style="height:45px"/>
                                    </div>
                                    <div style="white-space: nowrap;display: inline-block;padding-right:5px;">
                                            <img alt="Stackexchange" src="images/stackexchange-blog-traffic.png" style="height:45px"/>
                                    </div>
                            </div>
                            <br></br>
                            <!-- End icons -->

                            <!-- Begin dynamic Get Traffic -->    
                            
                            <h1><table cellspacing="0" cellpadding="0" style="display:inline-block;white-space:nowrap;min-height: 75px;"><tr><td><span id="dynamicVerb" class="dynamicTitleClass" style="min-height: 75px;min-height: 75px;">Get </span></td></tr></table> <img src="images/yellow-edge-left.png"/><table cellspacing="0" cellpadding="0" style="display:inline-block;white-space:nowrap;background-color: #ffff00;min-height: 75px;"><tr><td><span id="dynamicTitle" class="dynamicTitleClass" style="min-height: 75px;background-color: #ffff00;min-height: 75px;"></span></td></tr></table><img src="images/yellow-edge-right.png"/></h1>
                            
                            <!-- End dynamic Get Traffic -->

                            <h1 class="heading-core-extra-large" style="font-size: 30px;color:#ff642d;">Blog Traffic Infuser</h1>
                            <div class="lead-core-main">
                                <p>Automated discovery service to find social media questions answered directly by your blog posts. <strong>Driving massive targeted traffic to yours site.</strong></p>
                            </div>
                            <div class="text-under-core-left">
                                <a href="/signup" class="button-main-core button-main-core--brand button-main-core--l">Try It Free</a>
                                <p class="gray-under-color-semi text-under-core-s margin-core-main-top-2">15-day free trial. No obligation.</p>
                            </div>
                        </div>
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@l">

                            <img id="dynamicImage" />
                            <div style="float:right;padding-right:150px;"><img src="images/ssl-secure.png" style="height:90px;"/></div>
                         
                        </div>
                    </div>
                </div>
            </section>

            <a name="how-it-works"></a>
            <section class="core-block-section core-block-section--gray padding-main-bottom-10" style="padding-top:0px;margin-top:0px;">
                <div class="container-main-object">

                    <div class="core-block-section__header margin-core-main-bottom-12x">
                        <div class="grid-main-core">
                            <div class="grid-main-core__unit grid-main-core__unit--10of12@l grid-main-core__unit--offset-1of12@l">
                                <h2 class="core-block-section__heading">
                                    How It Works
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div style="padding-top:0px;margin-top: 0px;padding-bottom:0px;margin-bottom: 0px;text-align: center;width: 100%;">
                        <div style="padding-top:0px;margin-top: 0px;padding-bottom:0px;margin-bottom: 0px;text-align: center;max-width: 100%;">
                        
                        <video style="max-width: 650px;border: 1px solid #ff642d;" widthXX="320" heightXX="240" controls>
                            <source src="videos/TrafficInfuser-How-It-Works.mp4" type="video/mp4">
                          Your browser does not support the video tag.
                          </video>
                        </div>
               
                    </div>
                    <div classx="grid-main-core"  style="padding-top:0px;margin-top:0px;">
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@l grid-main-core__unit--offset-3of12@l text-under-core-center margin-core-main-top-10" style="padding-top:25px !important;margin-top:0px !important;">
                              
                                <a class="button-main-core button-main-core--brand" href="/signup">Get Started Free</a>
                         
                        </div>
                    </div>
                </div>
            </section>

            <!-- Neil Patel on Quora     
            <section class="core-block-section core-block-section--white" style="width:100%;">

            <div style="text-align: center;min-width: 100%;">
                <div style="text-align: center;max-width: 100%;">
                
                    <h2 class="core-block-section__heading">What <b>Neil Patel</b> Has To Say...</h2>
                    
                    <p>Traffic Infuser is based on the same concept explained in the video below, but not just for Quora.</p>
                    <p>Traffic Infuser applies the same traffic strategy to Facebook, Reddit, Twitter, YouTube, and Stack Exchange. </p>

                    <video style="max-width: 240px;border: 1px solid #ff642d;" controls>
                        <source src="videos/Neil-Patel-On-Quora.mp4" type="video/mp4">
                        Your browser does not support the HTML5 video tag.
                    </video>
                    

                    <div style="padding-top: 0px;font-size:14px;">
                        <i><b>Note:</b>This is not an endorsement from Neil Patel</i><br>
                        Video Source: <a target="_blank" href="https://www.instagram.com/reel/Cgskx90FcS_/?igshid=MDJmNzVkMjY%3D">https://www.instagram.com/reel/Cgskx90FcS_/?igshid=MDJmNzVkMjY%3D</a><br>
                        Video Author: <a target="_blank" href="https://www.instagram.com/neilpatel/?hl=en">Neil Patel</a><br>
                    </div>

                </div>
            </div>

        </section>

        -->

        <!-- Neil Patel on Quora -->
            
            <section class="core-block-section padding-main-bottom-10">
                <div class="container-main-object">
                    <div class="core-block-section__header margin-core-main-bottom-12">
                        <div class="grid-main-core">
                            <div class="grid-main-core__unit grid-main-core__unit--8of12@l grid-main-core__unit--offset-2of12@l">
                                <h2 class="core-block-section__heading">Steps to Drive Massive Traffic to Your Blog</h2>
                                All you have to do is sign up, it takes only 1 minute and it is free to try.<br>
                                You provide your <strong>blog URL</strong> and your <strong>blog theme</strong> and we do the rest. <br/>Below is how the entire process works:
                            </div>
                        </div>
                    </div>
                    <div class="grid-main-core">
                        <div class="grid-main-core__unit grid-main-core__unit--12of12@l">
                            <div class="grid-main-core">
                                <div class="grid-main-core__unit grid-main-core__unit--4of12@l">
                                    <span class="card-main-core card-main-core--gray margin-core-main-bottom-10" style="min-height: 400px;">
                                        <span class="icon-main-core icon-main-core--64x64-email-finder card-main-core__icon"></span>
                                        <div style="text-align: center">
                                            <img src="images/1.png" style="height:30px;"/>
                                            <h3 class="heading-core-super" style="color:#ff642d;">Sign Up</h3>
                                        </div>
                                        <p>When you sign up you will provide your <strong>blog URL</strong> and your <strong>blog theme</strong> i.e. fashion, weight-loss.</p>
                                        <p><strong>That's it, we do the rest!</strong></p>
                                        <p>It is <strong>free</strong> to sign-up to try it.</p>
                                        <a class="color-seasonal-1" style="cursor: pointer;"  href="/signup">Sign Up Now!</a>
                                    </span>
                                </div>
                                <div class="grid-main-core__unit grid-main-core__unit--4of12@l">
                                    <span class="card-main-core card-main-core--gray margin-core-main-bottom-10" style="min-height: 400px;">
                                        <span class="icon-main-core icon-main-core--64x64-pigeon card-main-core__icon"></span>
                                        <div style="text-align: center">
                                            <img src="images/2.png" style="height:30px;"/>
                                            <h3 class="heading-core-super" style="color:#ff642d;">Ingest Posts</h3>
                                        </div>
                                        <p>As soon as you sign up, we will assign one of our programmers to write code to identify all the blog posts from your website. This program will run regularly to monitor new posts on your blog. </p>
                                       
                                    </span>
                                </div>
                                <div class="grid-main-core__unit grid-main-core__unit--4of12@l">
                                    <span  class="card-main-core card-main-core--gray margin-core-main-bottom-10" style="min-height: 400px;">
                                        <span class="icon-main-core icon-main-core--64x64-rocket card-main-core__icon"></span>
                                        <div style="text-align: center">
                                            <img src="images/3.png" style="height:30px;"/>
                                            <h3 class="heading-core-super" style="color:#ff642d;">Identify Groups</h3>
                                        </div>
                                        <p>Our team will manually analyze your blog and identify the right groups and communities on Facebook, Reddit, and Quora related to your blog.</p>
                                        <p> This is where we will look for questions and conversations related to your blog posts. </p>
                                       
                                    </span>
                                </div>

                                <div class="grid-main-core__unit grid-main-core__unit--4of12@l">
                                    <span class="card-main-core card-main-core--gray margin-core-main-bottom-10" style="min-height: 455px;"    >
                                        <span class="icon-main-core icon-main-core--64x64-email-finder card-main-core__icon"></span>
                                        <div style="text-align: center">
                                            <img src="images/4.png" style="height:30px;"/>
                                            <h3 class="heading-core-super" style="color:#ff642d;">Conversation Discovery</h3>
                                        </div>
                                        <p>Our AI technology will search social media sites daily for conversations and questions that are directly answered by your blog posts.</p>
                                        <p>The matched conversations and questions will appear on your dashboard. An email will also be sent to you notifying you about the number of new matches found daily.</p>
                                        
                                    </span>
                                </div>
                                <div class="grid-main-core__unit grid-main-core__unit--4of12@l">
                                    <span class="card-main-core card-main-core--gray margin-core-main-bottom-10" style="min-height: 455px;">
                                        <span class="icon-main-core icon-main-core--64x64-pigeon card-main-core__icon"></span>
                                        <div style="text-align: center">
                                            <img src="images/5.png" style="height:30px;"/>
                                            <h3 class="heading-core-super" style="color:#ff642d;">15 Minutes a Day</h3>
                                        </div>
                                        <p>Now you have tons of social media conversations and questions that are directly answered by your blog posts.</p>
                                        <p>You can log in daily and open the social media questions found on your dashboard, provide a short answer and paste a link to your post for a more detailed answer to their question.</p>
                                      
                                    </span>
                                </div>
                                <div class="grid-main-core__unit grid-main-core__unit--4of12@l">
                                    <span  class="card-main-core card-main-core--gray margin-core-main-bottom-10" style="min-height: 455px;">
                                        <span class="icon-main-core icon-main-core--64x64-rocket card-main-core__icon"></span>
                                        <div style="text-align: center">
                                            <img src="images/6.png" style="height:30px;"/>
                                            <h3 class="heading-core-super" style="color:#ff642d;">Results</h3>
                                        </div>
                                        <p>You will drive massive targeted visitors daily to your posts, allowing you to engage your audience where they need you and when they are looking for your content.</p>
                                        <p>All this with only 15 minutes of work daily.</p>
                                        <p><strong>No more endless hours in front of a computer on social media to get traffic.</strong></p>
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-main-core">
                    <div class="grid-main-core__unit grid-main-core__unit--6of12@l grid-main-core__unit--offset-3of12@l text-under-core-center">
                        <a href="/pricing.html" class="button-main-core button-main-core--neutral">See Plans &amp; Pricing</a>
                    </div>
                </div>
            </section>
            <section class="core-block-section core-block-section--gray core-block-section--home-integrations padding-main-top-10">
                <div class="container-main-object">
                    <div class="core-block-section__header">
                        <div class="grid-main-core">
                            <div class="grid-main-core__unit grid-main-core__unit--8of12@l grid-main-core__unit--offset-2of12@l">
                               
                                <h2 class="core-block-section__heading">Social Networks</h2>
                                <p>We currently search for social conversations and questions related to your blog posts on the following social networks:</p>
                         
                            </div>
                        </div>
                    </div>
                    <div classX="grid-main-core" style="text-align: center;width:100%;">
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@m grid-main-core__unit--3of12@xl" style="white-space: nowrap;display: inline-block;">
                            <a href="https://facebook.com" target="_blank" class="card-main-core card-main-core--white text-under-core-center">
                                <img alt="Facebook" src="images/facebook-logo.png" />
                            </a>
                        </div>
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@m grid-main-core__unit--3of12@xl" style="white-space: nowrap;display: inline-block;">
                            <a href="https://quora.com" target="_blank" class="card-main-core card-main-core--white text-under-core-center">
                                <img alt="Quora" src="images/quora-logo.png" />
                            </a>
                        </div>
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@m grid-main-core__unit--3of12@xl" style="white-space: nowrap;display: inline-block;">
                            <a href="https://reddit.com" target="_blank" class="card-main-core card-main-core--white text-under-core-center">
                                <img alt="Reddit" src="images/reddit-logo.png" />
                            </a>
                        </div>
                        <br>
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@m grid-main-core__unit--3of12@xl" style="white-space: nowrap;display: inline-block;">
                            <a href="https://twitter.com" target="_blank" class="card-main-core card-main-core--white text-under-core-center">
                                <img alt="Twitter" src="images/twitter-logo.png" />
                            </a>
                        </div>
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@m grid-main-core__unit--3of12@xl" style="white-space: nowrap;display: inline-block;">
                            <a href="https://youtube.com" target="_blank" class="card-main-core card-main-core--white text-under-core-center">
                                <img alt="Youtube" src="images/youtube-logo.png" />
                            </a>
                        </div>
                        <div class="grid-main-core__unit grid-main-core__unit--6of12@m grid-main-core__unit--3of12@xl" style="white-space: nowrap;display: inline-block;">
                            <a href="https://stackexchange.com" target="_blank" class="card-main-core card-main-core--white text-under-core-center">
                                <img alt="Stackexchange" src="images/stackexchange-logo.png" />
                            </a>
                        </div>

                        
                        <p>We are constantly adding new social networks to expand your social reach.</p>
                    </div>
                </div>
            </section>
            <a name="demo"></a>
            <section class="core-block-section core-block-section--white" style="width:100%;">

                <div style="text-align: center;min-width: 100%;">
                    <div style="text-align: center;max-width: 100%;">
                    
                        <h2 class="core-block-section__heading">Demo</h2>
                        
                        <p>Click the demo below to see how you can drive massive targeted traffic to your blog with only 15 minutes a day.</p>
                        <p>TrafficInfuser brings the revelant conversations to you, all you need to do is answer the questions and paste your post link. </p>

                        
                        <video style="max-width: 80%;border: 1px solid #ff642d;" controls muted preload="metadata" style=" width:px;  height:px;">
                            <source src="videos/TrafficInfuser-Demo.mp4" type="video/mp4">
                            Your browser does not support the HTML5 video tag.
                        </video>
                        

                <!--

                        <iframe width="800" height="504" src="https://www.youtube.com/embed/Ek2OfZWhUSA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    -->
                        
                    <div style="padding-top: 20px;">
                        <a class="button-main-core button-main-core--brand" href="/signup">Get Started Free</a>
                    </div>

                    </div>
                </div>

            </section>
           
        </main>
        <footer class="footer-core-main" role="contentinfo">
            <div class="container-main-object">
                <div class="grid-main-core">
                    <div class="grid-main-core__unit grid-main-core__unit--12of12 grid-main-core__unit--2of12@l">
                        <a href="/" class="footer-core-main__brand">

                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="35" height="35" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1040 1056">
                                <title>TrafficInfuser</title>
                                <path d="M210 899q-10 21-16 30t-21.5 20.5t-41 17T65 973q1-32 4.5-54.5T77 883t13.5-23t17-14.5T130 833q39-19 62-37l-39-50q-15 11-52 30q-38 19-57.5 39T12 880.5T0 1004l1 33l31-1q62 0 103-6t66-21.5t38-31.5t27-45q15-31 22-44l-47-43q-7 9-13.5 19.5t-9.5 17t-8 17.5zm495-694q-53 0-90.5 37.5T577 333q0 35 17 64.5t46.5 46.5t64.5 17t64.5-17t46.5-46.5t17-64.5q0-21-6.5-40.5t-18-35.5t-27.5-27.5t-35.5-18T705 205zm-.5 192q-26.5 0-45-19T641 333t18.5-45t45.5-19q17 0 32 8.5t23.5 23.5t8.5 32q0 26-19 45t-45.5 19zM1024 45q-1-12-9.5-20.5T994 15q-4 0-10.5-.5T955 14t-45 1t-56.5 4.5t-66 9t-71 15.5T643 67q-92 34-163 117q-9 10-17.5 21.5T445 233t-16 27.5t-17.5 32T396 323t-17 33.5t-15 29.5l-7 14l-6 12.5l-7 13.5l-6 11.5l-6 12l-6 10.5H148q-14 0-24 10L7 598q-12 13-6.5 30.5T24 650l191 44q12 15 69 78l72 80l39 165q4 18 22 23q1 1 2.5 1t3.5.5t3 .5q12 0 21-8l119-118q2-2 4.5-5t4-6t2-6.5t.5-6.5V727q7-5 17.5-11t29-16t24.5-13q18-11 75-40.5t93.5-51T873 556q45-40 68-74.5t41-83.5q15-41 25-92t13.5-92t4.5-83t0-59t-1-27zM922 375q-16 43-34.5 71T831 508q-18 16-54 37t-89 48t-71 38q-81 45-92 54q-3 2-5 5t-3.5 6t-2.5 6.5t-1 7.5v167l-68 74l-28-121q-3-9-8-14q-145-162-154-172q-4-4-8.5-7t-9.5-4L91 600l72-76h182q2 0 5-.5t5.5-1.5t5-2.5t4.5-3t3.5-3.5t3.5-5q14-22 49-93q3-5 16.5-32t18.5-37.5t17-33t19.5-35T510 250t18-25q60-70 137-98q133-50 296-49q3 184-39 297z" 
                                fill="#ff642d"/>
                            </svg>
                              
                            <span class="heading-core-extra-large" style="font-size:14px;padding-left:10px;padding-right:40px;color:#ff642d;">Traffic Infuser</span>  
                        </a>
                    </div>
              
                    <div class="grid-main-core__unit grid-main-core__unit--6of12 grid-main-core__unit--4of12@m grid-main-core__unit--2of12@l margin-core-main-bottom-5 margin-core-main-bottom-0@l">
                        <h5 class="sitemap-main-core__heading">Plans</h5>
                        <ul class="sitemap-main-core__list">
                            <li class="sitemap-main-core__item">
                                <a href="pricing.html" class="sitemap-main-core__link">Pricing</a>
                            </li>
                        </ul>
                    </div>
                    <!--
                    <div class="grid-main-core__unit grid-main-core__unit--6of12 grid-main-core__unit--4of12@m grid-main-core__unit--2of12@l margin-core-main-bottom-5 margin-core-main-bottom-0@l">
                        <h5 class="sitemap-main-core__heading">Resources</h5>
                        <ul class="sitemap-main-core__list">
                           <li class="sitemap-main-core__item">
                                <a href="/blog/" class="sitemap-main-core__link">Blog</a>
                            </li>
                            
                        </ul>
                    </div>
                    -->
                    <div class="grid-main-core__unit grid-main-core__unit--6of12 grid-main-core__unit--4of12@m grid-main-core__unit--2of12@l margin-core-main-bottom-5 margin-core-main-bottom-0@l">
                        <h5 class="sitemap-main-core__heading">Company</h5>
                        <ul class="sitemap-main-core__list">
                            <li class="sitemap-main-core__item">
                                <a href="about-us.html" class="sitemap-main-core__link">About Us</a>
                            </li>
                        </ul>
                    </div>
                    <div class="grid-main-core__unit grid-main-core__unit--6of12 grid-main-core__unit--4of12@m grid-main-core__unit--2of12@l margin-core-main-bottom-5 margin-core-main-bottom-0@l">
                        <h5 class="sitemap-main-core__heading">Help &amp; Support</h5>
                        <ul class="sitemap-main-core__list">
                            <li class="sitemap-main-core__item">
                                <a href="contact-us.html" class="sitemap-main-core__link">Contact Us</a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
                <div class="footer-core-main__info" style="padding-top: 0px;margin-top: 0px;">
                    <div class="footer-core-main__links">
                        <span class="footer-core-main__copyright">© 2022 Traffic Infuser</span>
                        <ul class="footer-core-main__list">
                     
                            <li class="footer-core-main__item">
                                <a href="security.html">Security</a>
                            </li>
                            <li class="footer-core-main__item">
                                <a href="privacy-policy.html">Privacy</a>
                            </li>
                            <li class="footer-core-main__item">Copyright &#169; 2022 Traffic Infuser.</li>
                        </ul>
                    </div>
                    <!-- Social Media Links: Uncomment once the social media pages are setup

                    <div class="footer-core-main__social">
                        <ul class="footer-core-main__list">
                            <li class="footer-core-main__item">
                                <a href="https://twitter.com/trafficinfuser/" rel="noopener noreferrer" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <title>TrafficInfuser Twitter</title>
                                        <path
                                            fill="#fff"
                                            fill-opacity=".6"
                                            d="M23.954 4.38170913C23.069 4.78054032 22.124 5.05223766 21.129 5.17629569c1.014-.62644179 1.794-1.61377967 2.163-2.79181832C22.341 2.95350387 21.287 3.36771415 20.165 3.59840057 19.269 2.61516379 17.992 2 16.574 2c-2.717.0-4.92 2.25867637-4.92 5.04126724C11.654 7.4411237 11.699 7.82560107 11.781 8.19367407 7.691 7.99579638 4.066 5.98216025 1.64 2.93812478 1.213 3.67837187.974 4.5385759.974 5.4756754c0 1.75321679.87 3.29420208 2.188 4.19951812C2.355 9.64853642 1.596 9.42092582.934 9.04362537V9.10616702c0 2.44527608 1.693 4.48454398 3.946 4.94899268-.413.113805299999999-.849.1753217-1.296.1753217C3.27 14.2304814 2.969 14.1997232 2.668 14.1423079c.631 2.0023581 2.445 3.4623468 4.604 3.5033578-1.68 1.352335-3.809 2.1581996-6.102 2.1581996C.78 19.8038653.391 19.780284.0 19.735172 2.189 21.1644025 4.768 22 7.557 22c9.054.0 13.999-7.6854463 13.999-14.33946788.0-.21428206.0-.43061465-.0150000000000006-.64592198C22.502 6.30819706 23.341 5.41518429 24.001 4.40221459L23.954 4.38170913z"
                                        ></path>
                                    </svg>
                                </a>
                            </li>
                            <li class="footer-core-main__item">
                                <a href="https://www.facebook.com/trafficinfuser/" rel="noopener noreferrer" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <title>TrafficInfuser Facebook</title>
                                        <path
                                            fill="#fff"
                                            fill-opacity=".6"
                                            d="M23.9981 12.0733511C23.9981 5.40540323 18.626.0 11.9991.0 5.37216.0.0 5.40540323.0 12.0733511.0 18.099512 4.38789 23.0942295 10.1242 24V15.5633144H7.07758V12.0733511H10.1242V9.41342255c0-3.02587916 1.7914-4.69727826 4.5322-4.69727826 1.3128.0 2.686.23580017 2.686.23580017V7.92311717h-1.513c-1.4906.0-1.9555.93066358-1.9555 1.88544549V12.0733511h3.3279l-.532 3.4899633H13.8739V24C19.6103 23.0942295 23.9981 18.099512 23.9981 12.0733511z"
                                        ></path>
                                    </svg>
                                </a>
                            </li>
                            <li class="footer-core-main__item">
                                <a href="https://www.instagram.com/trafficinfuser/" rel="noopener noreferrer" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <title>Traffic Infuser Instagram</title>
                                        <path
                                            fill="#fff"
                                            fill-opacity=".6"
                                            d="M12 0C8.74.0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384C1.347 2.681.935 3.35.63 4.14.333 4.905.131 5.775.072 7.053.012 8.333.0 8.74.0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384C4.906 23.666 5.776 23.869 7.053 23.928 8.333 23.988 8.74 24 12 24S15.667 23.985 16.947 23.928C18.224 23.868 19.095 23.666 19.86 23.37 20.648 23.064 21.319 22.652 21.986 21.986 22.652 21.319 23.065 20.651 23.37 19.86 23.666 19.095 23.869 18.224 23.928 16.947 23.988 15.667 24 15.26 24 12S23.985 8.333 23.928 7.053C23.868 5.776 23.666 4.904 23.37 4.14 23.064 3.351 22.652 2.681 21.986 2.014 21.319 1.347 20.651.935 19.86.63 19.095.333 18.224.131 16.947.072 15.667.012 15.26.0 12 0zm0 2.16C15.203 2.16 15.585 2.176 16.85 2.231 18.02 2.286 18.655 2.48 19.077 2.646 19.639 2.863 20.037 3.123 20.459 3.542 20.878 3.962 21.138 4.361 21.355 4.923 21.519 5.345 21.715 5.98 21.768 7.15 21.825 8.416 21.838 8.796 21.838 12S21.823 15.585 21.764 16.85C21.703 18.02 21.508 18.655 21.343 19.077 21.119 19.639 20.864 20.037 20.444 20.459 20.025 20.878 19.62 21.138 19.064 21.355 18.644 21.519 17.999 21.715 16.829 21.768 15.555 21.825 15.18 21.838 11.97 21.838 8.759 21.838 8.384 21.823 7.111 21.764 5.94 21.703 5.295 21.508 4.875 21.343 4.306 21.119 3.915 20.864 3.496 20.444 3.075 20.025 2.806 19.62 2.596 19.064 2.431 18.644 2.237 17.999 2.176 16.829 2.131 15.569 2.115 15.18 2.115 11.985 2.115 8.789 2.131 8.399 2.176 7.124 2.237 5.954 2.431 5.31 2.596 4.89 2.806 4.32 3.075 3.93 3.496 3.509c.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421C8.371 2.145 8.746 2.13 11.955 2.13L12 2.16zm0 3.678c-3.405.0-6.162 2.76-6.162 6.162.0 3.405 2.76 6.162 6.162 6.162 3.405.0 6.162-2.76 6.162-6.162.0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21.0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zM19.846 5.595C19.846 6.39 19.2 7.035 18.406 7.035 17.611 7.035 16.966 6.389 16.966 5.595 16.966 4.801 17.612 4.156 18.406 4.156 19.199 4.155 19.846 4.801 19.846 5.595z"
                                        ></path>
                                    </svg>
                                </a>
                            </li>
                            <li class="footer-core-main__item">
                                <a href="https://www.linkedin.com/company/trafficinfuser/" rel="noopener noreferrer" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <title>Traffic Infuser Linkedin</title>
                                        <path
                                            fill="#fff"
                                            fill-opacity=".6"
                                            d="M20.447 20.452H16.893V14.883C16.893 13.555 16.866 11.846 15.041 11.846c-1.853.0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561H12.811c.477-.9 1.637-1.85 3.37-1.85 3.601.0 4.267 2.37 4.267 5.455v6.286H20.447zM5.337 7.433c-1.144.0-2.063-.926-2.063-2.065.0-1.138.92-2.063 2.063-2.063 1.14.0 2.064.925 2.064 2.063.0 1.139-.925 2.065-2.064 2.065zM7.119 20.452H3.555V9H7.119V20.452zM22.225.0H1.771C.792.0.0.774.0 1.729V22.271C0 23.227.792 24 1.771 24H22.222C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2.0 22.222.0H22.225z"
                                        ></path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                -->
                </div>
            </div>
        </footer>
      
    </body>



</html>


`;

class main extends Component {

	constructor(props) {
		super(props);

		this.indexPageElement = null;

	}

	componentDidMount= () => {
		
		$(this.indexPageElement).find('[data-my-script]').each(function forEachScript() {
			const script = $(this).text();
			window.eval(script);
		  });
	
	  };

	
	render() {

			return (
				
			<div>
				<div
					ref={indexPageElement => (this.indexPageElement = indexPageElement)} 
					dangerouslySetInnerHTML={{__html: contentHTML}} 
				>
					
				</div>

			  </div>
	)};

}


export default main;
